/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

import upload from '@/utils/axiosUpload';
import { showActionSheet } from '@/utils/installActionSheet.js';
export default {
  name: 'fileupload',
  props: {
    target: {
      type: String
    },
    action: {
      type: String
    },
    multiple: {
      type: Boolean,
      default: true
    },
    oss: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: '*/*'
    }
  },
  data: function data() {
    return {
      file: null
    };
  },
  mounted: function mounted() {
    if (this.multiple) {
      this.$refs.file.setAttribute('multiple', true);
    }
  },
  methods: {
    emitter: function emitter(event, data) {
      this.$emit(event, data);
    },
    updateProgress: function updateProgress(oEvent) {
      var vm = this;
      if (oEvent.lengthComputable) {
        var percentComplete = Math.round(oEvent.loaded * 100 / oEvent.total);
        vm.emitter('progress', percentComplete);
      } else {
        // Unable to compute progress information since the total size is unknown
        vm.emitter('progress', false);
      }
    },
    onFileChange: function onFileChange(e) {
      var _this2 = this;
      var vm = this;
      function uploadFile(file) {
        var _this = this;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    upload({
                      action: _this.action,
                      target: _this.target,
                      file: file,
                      filename: file.name,
                      onProgress: vm.updateProgress,
                      onStart: function onStart(res) {
                        _this.emitter('start', res);
                      },
                      onEnd: function onEnd(res) {
                        console.log('AutoConsole: uploadFile -> res', res);
                        _this.emitter('finish', res);
                        resolve(e);
                      }
                    });
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
      if (!this.target || this.target === '') {
        console.log('Please provide the target url');
      } else if (!this.action || this.action === '') {
        console.log('Please provide file upload action ( POST / PUT )');
      } else if (this.action !== 'POST' && this.action !== 'PUT') {
        console.log('File upload component only allows POST and PUT Actions');
      } else {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          return;
        }
        if (this.multiple) {
          var uploadList = Array.from(files).map(function (file) {
            return uploadFile.call(_this2, file);
          });
          Promise.all(uploadList);
        } else {
          uploadFile.call(this, files[0]);
        }
      }
    },
    clickUpload: function clickUpload() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                showActionSheet({
                  menus: [i18n.tc("536"), i18n.tc("537"), i18n.tc("538")].map(function (v, index) {
                    return {
                      key: index,
                      label: v
                    };
                  })
                }).$once('on-click-menu', function (_, item) {
                  if (item) {
                    var keyMap = {
                      0: 'photo',
                      1: 'video',
                      2: 'file'
                    };
                    _this3.$refs[keyMap[item.key]].click();
                  }
                });
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};